import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { LoginBackgroundComponent } from './login/login-background/login-background.component';
import { LoginRedirectComponent } from './loginrediect/loginredirect.component';
import { AngularMaterialModule } from '../angular.material.module';
import { GoogleredirectComponent } from './googleredirect/googleredirect.component';

@NgModule({
  declarations: [
    LoginComponent,
    LoginBackgroundComponent,
    LoginRedirectComponent,
    GoogleredirectComponent,
  ],
  imports: [CommonModule, AngularMaterialModule],
})
export class AuthModule {}
